import { useTranslation } from 'react-i18next';
import { Button, CheckBox, Popover } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { useSelectItemIds } from '@anytag/shared-hooks';
import { AnalyticsInstagramDashboardLegendType, AnalyticsInstagramDashboardGraphKeys as Keys } from '../types';
import { getAllLegendOptions, getDropdownLegendKeys } from '../utils';

interface Props {
  isInfluencerProfile?: boolean;
}
export const useAnalyticsInstagramDashboardOverviewLegend = ({ isInfluencerProfile }: Props) => {
  const { t } = useTranslation();
  const { setSelectedItemIds: setSelectedDropdownLegendKeys, selectedItemIds: selectedDropdownLegendKeys } =
    useSelectItemIds<Keys>();
  const {
    selectItem: setSelectingDropdownLegendKey,
    selectedItemIds: selectingDropdownLegendKeys,
    setSelectedItemIds: setSelectingDropdownLegendKeys
  } = useSelectItemIds<Keys>();

  const allLegendOptions = getAllLegendOptions(isInfluencerProfile);
  const dropdownLegendKeys = getDropdownLegendKeys(isInfluencerProfile);
  const legendOptions: AnalyticsInstagramDashboardLegendType[] = allLegendOptions.map((option) => ({
    ...option,
    label: option.label ? t<string>(option.label) : ''
  }));
  const availableLegendOptions = legendOptions.filter(
    ({ value }) => !dropdownLegendKeys.includes(value) || selectedDropdownLegendKeys.includes(value)
  );

  return {
    availableLegendOptions: isInfluencerProfile ? availableLegendOptions : allLegendOptions,
    ButtonSelectMoreLegendOptions: (
      <Popover
        onClose={() => setSelectingDropdownLegendKeys(selectedDropdownLegendKeys)}
        side="bottom"
        align="end"
        target={({ togglePopover }) => (
          <Button
            variant="outline"
            onClick={togglePopover}
            prefixIcon={{ icon: 'plus', size: 12 }}
            css={{
              marginLeft: isInfluencerProfile ? '12px' : 'auto',
              backgroundColor: THEME.background.colors.gray.lv1
            }}
          />
        )}
      >
        {({ togglePopover }) => (
          <div className="min-w-62 shadow-container">
            <div className="p-2">
              {dropdownLegendKeys.map((key) => (
                <CheckBox
                  key={key}
                  className="not-first-of-type:mt-4"
                  onClick={() => setSelectingDropdownLegendKey(key)}
                  checked={selectingDropdownLegendKeys.includes(key)}
                  label={legendOptions.find((item) => item.value === key)?.label}
                />
              ))}
            </div>
            <div className="border-t-border p-2">
              <Button
                variant="solid"
                title={t('Button.Save')}
                css={{ minWidth: '66px', height: '24px', marginLeft: 'auto', textTransform: 'uppercase' }}
                onClick={() => {
                  setSelectedDropdownLegendKeys(selectingDropdownLegendKeys);
                  togglePopover();
                }}
              />
            </div>
          </div>
        )}
      </Popover>
    )
  };
};
